import $store from '@/store'
const ignoreUrls = [
  '/signup/complete',
  '/my/store/register',
  '/my/business/register',
  '/my/register/complete',
  '/my/malls',
  '/my/plans',
  '/signup/mall',
  '/signup/platform/require',
  '/signup/platform/notavailable',
  '/terms',
]

// ignore router 체크
const isIgnore = (to) => {
  return !!ignoreUrls.find((el) => to.path.indexOf(el) > -1)
}

export default async (to, from, next) => {
  if (isIgnore(to) === false && $store.getters['auth/isAuthenticated'] === true) {
    if (!$store.state.auth.me) {
      // 로딩중이면 대기하게
      await $store.dispatch('auth/getMe')
    }
    if (!$store.state.mall.malls) {
      // 로딩중이면 대기하게
      await $store.dispatch('mall/getMalls')
    }
    // console.log($store.state.auth.me.planChoice)
    // if ($store.getters['auth/isEmptyStoreSet']) {
    //   return next('/my/store/register')
    // } else if ($store.getters['auth/isEmptyBusinessSet']) {
    //   return next('/my/business/register')
    // } else
    // if ($store.getters['mall/isMallsAvailable'] === false) {
    //   return next('/my/malls')
    // }
    // if ($store.state.mall.malls.length === 0) {
    //   return next('/signup/mall')
    // }
    if ($store.state.mall.malls.length > 0 && !$store.state.auth.me.planChoice) {
      return next('/my/plans')
    }
  }
  next()
}
